/**
 * O Stripe.js (modo TESTE) injeta um iframe de "developer tools" (src com
 * `elements-inner-easel`) FIXO no canto inferior direito — com `display:block
 * !important` inline. Ele é GLOBAL do Stripe.js: persiste mesmo depois que o
 * `<Elements>` do checkout desmonta e o trader navega pra outra página.
 *
 * Com chaves LIVE o widget some sozinho; enquanto rodamos em teste, escondemos
 * via JS (stylesheet não vence o `!important` inline). O Stripe insere o iframe e
 * só DEPOIS seta o `src`, então não basta olhar no childList — re-checamos no
 * evento `load` do iframe + alguns timeouts. Não toca no PaymentElement (src
 * diferente).
 */
function hideIfEasel(el: Node): void {
  if (!(el instanceof HTMLIFrameElement)) return;
  const check = (): void => {
    if ((el.src || '').includes('elements-inner-easel')) {
      el.style.setProperty('display', 'none', 'important');
    }
  };
  check();
  el.addEventListener('load', check);
  // src é setado de forma assíncrona depois de inserir o iframe.
  setTimeout(check, 200);
  setTimeout(check, 1000);
  setTimeout(check, 3000);
}

export function installStripeDevWidgetHider(): void {
  if (typeof window === 'undefined' || !document.body) return;
  document.querySelectorAll('iframe').forEach((f) => hideIfEasel(f));
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) hideIfEasel(node);
    }
  });
  observer.observe(document.body, { childList: true });
}
